<template>
  <div class="lee-slide-image">
    <transition name="fade">
      <div class="float-slide" v-if="value" @mousedown.prevent="mousedown" @mousemove.prevent="mousemove"
           @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart"
           @touchmove.prevent="touchmove"
           @touchend.stop="touchend">
        <div class="slidecontainer"
             :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateX('+(movex+posx)+'px)'}">
          <div class="slide" v-for="(item,xh) in config" :key="xh">
            <img :src="item">
          </div>
        </div>
      </div>
    </transition>
    <div class="close" @click="gb" v-if="value"></div>
    <div class="page" v-if="value"><span>{{curpage}}</span>/{{config.length}}</div>
    <transition name="fade">
      <div class="mark" v-if="value"></div>
    </transition>
  </div>
</template>
<script>
export default {
    name: 'LeeSlideImage',
    inheritAttrs: false,
    data() {
        return {
            posx: 0,
            movex: 0,
            isdown: false,
            oldx: 0,
            curpage: 1,
            sw: 0
        }
    },
    mounted() {
        this.sw = window.innerWidth
        window.addEventListener('resize', () => {
            this.sw = window.innerWidth
        })

    },
    methods: {
        slideto(xh) {
            this.curpage=xh
        },
        mousedown() {
            this.isdown = true
            this.oldx = event.pageX
        },
        mousemove() {
            if (this.isdown) {
                this.movex = (event.pageX - this.oldx)
                if (this.curpage === 1) {//如果当前在第一张
                    if (this.movex > 0) {
                        this.movex = (event.pageX - this.oldx) * 0.4
                    }
                }
                if (this.curpage === this.config.length) {//如果当前在第一张
                    if (this.movex < 0) {
                        this.movex = (event.pageX - this.oldx) * 0.4
                    }
                }
            }
        },
        mouseup() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0

        },
        mouseleave() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0

        },
        touchstart() {
            this.isdown = true
            this.oldx = event.targetTouches[0].pageX
        },
        touchmove() {
            if (this.isdown) {
                this.movex = (event.targetTouches[0].pageX - this.oldx)
                if (this.curpage === 1) {//如果当前在第一张
                    if (this.movex > 0) {
                        this.movex = (event.targetTouches[0].pageX - this.oldx) * 0.4
                    }
                }
                if (this.curpage === this.config.length) {//如果当前在第一张
                    if (this.movex < 0) {
                        this.movex = (event.targetTouches[0].pageX - this.oldx) * 0.4
                    }
                }
            }
        },
        touchend() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0
        },
        gb() {
            this.$emit('input', false)
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false //默认default
        },
        config: {
            type: Array,
            default() {
                return []
            }
        }

    },
    watch: {
        sw: {
            immediate: true,
            handler(value) {
                this.posx = -value * (this.curpage - 1)
            }
        },
        curpage: {
            immediate: true,
            handler(value) {
                this.posx = -this.sw * (value - 1)
            }
        },
        value: {
            immediate: true,
            handler(value) {
                if (!value) {
                    this.posx = 0
                    this.movex = 0
                    this.curpage = 1
                }
            }
        }
    },
};
</script>
<style>

.lee-slide-image .float-slide {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  transition: all .3s;
  overflow: hidden;
  cursor: move;
}

.lee-slide-image .float-slide .slidecontainer {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
}

.lee-slide-image .float-slide .slide {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lee-slide-image .float-slide .slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain
}

.lee-slide-image .mark {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  background: rgba(0, 0, 0, .8);
  left: 0;
  top: 0;
  transition: all .3s;
}

.lee-slide-image .page {
  position: fixed;
  bottom: 10PX;
  left: 10px;
  z-index: 1006;
  color: #fff;
  padding: 0;
  font-size: 30px;
}

.lee-slide-image .page span {
  color: #f60;
}

.lee-slide-image .close {
  width: 40px;
  height: 40px;
  position: fixed;
  right: 10PX;
  top: 10px;
  cursor: pointer;
  z-index: 1006;
  transform: rotate(45deg);
}

.lee-slide-image .close:before {
  content: '';
  height: 100%;
  width: 2px;
  margin-left: -1px;
  left: 50%;
  background: #fff;
  position: absolute;
}

.lee-slide-image .close:after {
  content: '';
  width: 100%;
  height: 2px;
  top: 50%;
  margin-top: -1px;
  background: #fff;
  position: absolute;
}

/*遮罩動畫*/


.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

@media (max-width: 768px) {
  .lee-slide-image .close {
    width: 20px;
    height: 20px;
  }

  .lee-slide-image .page {
    font-size: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeSlideImage.vue